import { render, staticRenderFns } from "./StickyNoteRelation.vue?vue&type=template&id=d65300d8&scoped=true&"
import script from "./StickyNoteRelation.vue?vue&type=script&lang=js&"
export * from "./StickyNoteRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65300d8",
  null
  
)

export default component.exports